// extracted by mini-css-extract-plugin
export default {"content":"Layout_content__giedH","main":"Layout_main__wQCA6"};